'use client';

import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { InfoPanel } from '@/components/CA/InfoPanel';
import { Hero } from '@/components/Home/Hero';
import { SearchBar } from '@/components/Home/SearchBar';
import { useAtomValue } from 'jotai';
import { motion } from 'motion/react';
import { Suspense } from 'react';

/**
 * The home and /ca/:ca page.
 * The Hero search bar is shared between the two pages.
 * The Hero search shrinks into a compact variant on /ca/:ca pages.
 */
export const TokenSearch = () => {
  const tokenInfoResult = useAtomValue(tokenInfoAtom);
  const isHomePage = !tokenInfoResult;

  return (
    <motion.div className="container mx-auto px-4 py-12 w-full">
      {/* Hero section with inline ads */}
      <div className="flex justify-between items-start w-full mx-auto">
        {/* Center content with hero and search */}
        <motion.div
          className="flex flex-col items-center flex-1"
          initial={{ opacity: 0 }}
          animate={{
            scale: !isHomePage ? 0.75 : 1,
            y: !isHomePage ? -40 : 0,
            marginBottom: !isHomePage ? '0px' : '48px',
            opacity: 1,
          }}
          transition={{ duration: 1 }}
        >
          {/* Hero with ad to the right */}
          <Suspense fallback={<div>Loading...</div>}>
            <div className="flex flex-col md:flex-row items-center w-full">
              <Hero compact={!isHomePage} />
            </div>
          </Suspense>

          {/* Search bar only on home page */}
          {isHomePage && <SearchBar />}
        </motion.div>
      </div>

      {/* Info panel */}
      <div id="token-info-panel" className="w-full mx-auto">
        <InfoPanel />
      </div>
    </motion.div>
  );
};
